export default __webpack_public_path__ + "static/logo_black-ed41c34f83e8781ec343353e812239db.svg";